function ensureEnv(name: string, value?: string): string {
  if (value === undefined) {
    throw new Error(`Unknown env variable ${name}`);
  }
  return value;
}

export default ensureEnv;
